const inviteExpiryFormatter = new Intl.DateTimeFormat(undefined, {
  hour: "numeric",
  minute: "2-digit",
});

export function formatInviteExpiry(expiresAt: string): string {
  return inviteExpiryFormatter.format(new Date(expiresAt));
}
